'use client';

import { ValidationError, useForm } from '@formspree/react';
import { useEffect, useState } from 'react';
import { en } from '@/lib/content';

const { form } = en.contact;

export function ContactForm() {
  const [state, handleSubmit] = useForm('xeqbqqwj');
  const [displayBanner, setDisplayBanner] = useState(false);

  useEffect(() => {
    if (state.submitting) setDisplayBanner(false);
    if (state.succeeded) setDisplayBanner(true);
  }, [state]);

  return (
    <form onSubmit={handleSubmit}>
      {displayBanner && (
        <div className="messenger-box-contact__msg alert alert-success" role="alert">
          {form.onCompletion}
          <button type="button" className="btn-close" onClick={() => setDisplayBanner(false)} aria-label="Close" />
        </div>
      )}

      <div className="input-group">
        <input type="text" name="name" id="name" required placeholder="Name *" />
        <ValidationError prefix="Name" field="name" errors={state.errors} />
      </div>
      <div className="input-group">
        <input id="email" type="email" name="email" required placeholder="Email *" />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </div>
      <div className="input-group">
        <input type="text" name="topic" id="topic" required placeholder="Topic *" />
        <ValidationError prefix="topic" field="topic" errors={state.errors} />
      </div>
      <div className="input-group">
        <textarea name="message" id="message" required placeholder="Message *" />
        <ValidationError prefix="Message" field="message" errors={state.errors} />
      </div>
      <div className="input-group">
        <button className="theme-btn submit-btn" type="submit" disabled={state.submitting}>
          {form.button.text}
        </button>
      </div>
    </form>
  );
}
